<template>
  <div class="screen-table">
    <div class="screen-head">
      <span>{{ title }}</span>
    </div>

    <div class="screen-tb">
      <table>
        <tr class="head">
          <td colspan="6" style="font-size:12px">虫情数据 【{{ Date.now() | formatDate('YYYY-MM-DD') }}】</td>
        </tr>

        <tr class="content" v-for="(row, ridx) in shower" :key="`row-${ridx}`">
          <td class="label">{{ row[0].category }}</td>
          <td class="value">{{ row[0].today }}</td>
          <td class="label" v-if="row[1]">{{ row[1].category }}</td>
          <td class="value" v-if="row[1]">{{ row[1].today }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import * as api from '@/service/telemetry'
import sleep from '@/utlis/sleep'

export default {
  data() {
    return {
      loading: true,
      warnings: []
    }
  },
  computed: {
    title() {
      return this.$route.query.title || '物联网病虫害实时监测系统'
    },
    shower() {
      let data = []
      let cols = 2
      this.warnings.slice(0, 6).forEach((w, idx) => {
        let row = Math.floor(idx / cols)
        if (!data[row]) {
          data.push([w])
        } else {
          data[row].push(w)
        }
      })
      return data
    }
  },
  async mounted() {
    let { companyId, device, username, password } = this.$route.query
    this.login(username, password, companyId, device)
  },
  methods: {
    async login(username, password, companyId, device) {
      try {
        let user = this.$store.getters.user
        if (!(user && user.id)) {
          if (username && password) {
            await this.$store.dispatch('user/login', { username, password })
          }
        }

        if (companyId) {
          this.currentCompany = companyId
          await this.$store.dispatch('user/setCompanyId', companyId)
          await Promise.all([
            this.init(companyId, device),
            this.$store.dispatch('user/warmup')
          ])
        }
      } catch (e) {
        console.log(e)
        this.$message.error('用户信息错误')
      } finally {
        this.loging = false
      }
    },
    async init(companyId, key) {
      try {
        this.loading = true
        const [{ data }] = await Promise.all([
          api.getWarnings(companyId),
          sleep(1)
        ])
        this.warnings = data.warnings
          .filter(w => w.key === key)
          .sort((a, b) => b.today - a.today)
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.screen-table {
  width: 100%;
  height: 100%;
  background-color: #303133;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  color: #fff;
  padding: 2px;
  box-sizing: border-box;

  .screen-head {
    font-size: 10px;
    text-align: center;
    font-weight: bold;
    letter-spacing: 1px;
    // padding: 2px 0;
    // letter-spacing: 2px;
    margin-bottom: 2px;
    display: flex;
    justify-content: center;
    align-items: baseline;
    span {
      text-align: center;
    }
  }
  .screen-tb {
    flex: 1;
    &:not(:last-child) {
      margin-bottom: 2px;
    }
    table {
      border-collapse: collapse; /* 确保边框合并，这样就不会有多余的间隙 */
      width: 100%;
      height: 100%;
      border-spacing: 0;
    }
    td,
    th {
      border: 1px solid #67c23a; /* 为每个单元格添加边框 */
      text-align: center;
      height: 6px;
      line-height: 8px;
      box-sizing: border-box;
      vertical-align: middle;
      padding: 0;
    }
    .head {
      color: #ff6c6c;
      text-shadow: 0 0 1px #000;
    }
    .label {
      color: #e6a23c;
      width: 68px;
    }
  }
}
</style>
